import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import Button from "@mui/material/Button";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Iconify from "../../../components/iconify/iconify";
import { TableHeaderStyle } from "../../../theme/palette";

const columns = [
  "Name",
  "Username",
  "Email",
  "Role",
  "Status",
  "Last Login",
  "Actions",
];

export default function Users() {
  return (
    <div>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Stack>
          <Typography variant="h4">Users</Typography>
          <div
            style={{
              backgroundColor: TableHeaderStyle.border,
              height: "2px",
            }}
          />
        </Stack>

        <Tooltip title="User management is not available yet">
          <span>
            <Button
              variant="contained"
              disabled
              startIcon={<Iconify icon="eva:plus-fill" />}
              sx={{
                backgroundColor: "#28a745",
                "&:hover": { backgroundColor: "#218838" },
                fontWeight: "bold",
              }}
            >
              Add User
            </Button>
          </span>
        </Tooltip>
      </Stack>

      <Card>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ height: 96, px: 3 }}
        >
          <TextField
            size="small"
            placeholder="Search users..."
            inputProps={{ "aria-label": "Search users" }}
          />
        </Stack>

        <TableContainer sx={{ overflow: "unset" }}>
          <Table sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column}
                    sx={{
                      backgroundColor: TableHeaderStyle.bgColor,
                      color: TableHeaderStyle.color,
                      fontWeight: 700,
                    }}
                  >
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell colSpan={columns.length} align="center" sx={{ py: 5 }}>
                  <Typography color="text.secondary">No users found.</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </div>
  );
}
